// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"284108b6","150":"179a33ec","545":"6908aef9","551":"8e163186","605":"e99ce4b8","662":"c4031e0e"}[chunkId] + ".chunk.js";
};